import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, AfterViewInit, ElementRef, TemplateRef } from '@angular/core';
import { HtmlBase, HtmlButton, BreadcrumbModel, SegmentationItem, CustomgridModel, QueovalDik, SegmentationModel, CustomgridParam, BObjectModel, ParameterBoModel, QueovalParam, ModeBo, eAppContext } from '../models';
import { HttpService, CoreService, BreadcrumbService } from '../services';
import { DialogService } from '../dialog';
import { ModalService } from '../modal';
import { CustomGridService } from '../customgrid';
import * as _jquery from 'jquery';
import { GetHeaderHeight } from '../utilities';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
const $: JQueryStatic = _jquery;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-segmentation',
  templateUrl: './segmentation.component.html',
  styleUrls: ['./segmentation.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class SegmentationComponent implements OnInit, AfterViewInit {

  private baseTagsListHeight: number = 34;
  private baseHeaderHeight: number = 0;
  gridOffset: number = 0;
  activeButton: HtmlBase[];
  loadComponent: boolean;  // used to reload the html div containing the selected tab contento
  model: { component: string, model: any, title: string, activeButton?: Array<HtmlButton> };
  showModal: boolean;
  breadcrumb: BreadcrumbModel;
  tabsList: SegmentationItem[] = [];
  boModel: BObjectModel;
  paramBoModel: ParameterBoModel;
  indexSelect: number;
  customgridParams: CustomgridModel;
  modeBo = ModeBo;
  tempTabsList: SegmentationItem[] = [];
  count: number = 0;
  stopCondition: boolean = false;
  public rank: string = '0';
  public boName: string = '';
  public showConfig: boolean = false;

  public refreshData: boolean = false;
  @Input('item')
  set item(value: ParameterBoModel) {
    if (value) {
      this.paramBoModel = value;
      this.loadMenu(value, 0);
    }
  }
  @Input('mode') mode: string;

  @Input('showContextColumn') showContextColumn: boolean = true;

  @ViewChild('ModalSegmentation') ModalSegmentation: TemplateRef<HTMLTemplateElement>;

  @Output() boAfterSave: EventEmitter<BObjectModel> = new EventEmitter<BObjectModel>();
  @Output() sendEventGrid: EventEmitter<BreadcrumbModel> = new EventEmitter<BreadcrumbModel>();

  @HostListener('window:resize', ['$event'])
  onResize(event?: Event): any { this.setOffset(); }


  constructor(
    private http: HttpService,
    public indParam: CoreService,
    protected breadcrumpservice: BreadcrumbService,
    private customgridservice: CustomGridService,
    private cd: ChangeDetectorRef,
    private dialogservice: DialogService,
    private modalService: NgbModal,
    public sanitizer: DomSanitizer
  ) { }


  ngOnInit(): void {
    this.showConfig = this.indParam.AppParams.context == eAppContext.QUEOVAL;
    // action au click d'un bouton dans la grid
    this.customgridservice.getItem().subscribe((res: any) => {
      const param: QueovalParam = { params: new Array<QueovalDik>(), model: res };
      if (res.Action == 'ANG_SEGMENTATION_GRID') {
        this.breadcrumpservice.loadContextSegmentation(res.P1, res.P2, null, true);
      }
      else {
        switch (res.Action) {
          case 'ANG_SEGMENTATION':
          case 'ANG_SEGMENTATION_BREADCRUMB':
            this.breadcrumb = new BreadcrumbModel('add', 'q-segmentation', param, res.FILE, true);
            break;
          case 'ANG_INSERT_DOC':
            this.breadcrumb = new BreadcrumbModel('add', 'q-insertdoc', param, res.Header.Title, true);
            break;
          case 'ANG_CUSTOMGRID':
            this.breadcrumb = new BreadcrumbModel('add', 'q-customgrid', param, res.cgParameters.FileName, true);
            break;
          case 'ANG_PAGE':
            this.breadcrumb = new BreadcrumbModel('add', 'q-bodisplay', param, res.Header.Title, true);
            break;
          case 'SEARCH_PAGE':
            this.breadcrumb = new BreadcrumbModel('add', 'q-search', param, res.Header.Title, true);
            break;
          case 'ANG_LIEU_STAGE':
            // breadcrumb = new BreadcrumbModel('map', param, res.FILE, true);
            break;
        }
        this.modalService.open(this.ModalSegmentation, { size: 'xl', centered: true, windowClass: 'modal-segmentation' }).result.then((modalResult) => {
          switch (modalResult) {
            //  case 'SAVE': this.saveConfigSignature(); break;
            //  case 'CANCEL': this.closeConfigSignature(); break;
          }
        });
        this.showModal = true;
      }
      this.cd.detectChanges();
    });
  }

  ngAfterViewInit(): void {
    this.setOffset();
  }

  tabClick(index: number, tabItem: SegmentationItem): void {
    // deselect tab item previuosly selected
    for (const p of this.tabsList) p.isSelected = false;
    // select corrspondent tab item
    this.tabsList[index].isSelected = true;

    this.getModel(index, tabItem);
  }

  public OpenConfig(): void {
    let baseLink: string = '';
    switch (this.indParam.AppParams.context) {
      case eAppContext.QUEOVAL:
        baseLink = `view/segmentation/configuration`;
        break;
    }
    if (baseLink) {
      this.breadcrumb = new BreadcrumbModel('add', `${baseLink}`, null, "Édition de la segmentation", true, `idBo=${this.boName}&idDonnee=${this.boModel.IdDonneeFils}`);
      this.breadcrumpservice.call(this.breadcrumb);
      //window.open(`${this.indParam.AppParams.appUrl}Admin/PageAdminDisplay.aspx?P1=${this.boName}&P2=${this.boModel.IdDonneeFils}`, '_blank');
    }
  }

  getEvent(bo: BObjectModel, modalSegmentation: any = null): void {
    if (modalSegmentation)
      modalSegmentation.close();
    this.loadMenu(this.paramBoModel, this.indexSelect);
    this.cd.detectChanges();
  }

  public RefreshGrid(success: boolean, modalSegmentation: any) {
    if (success) {
      if (modalSegmentation)
        modalSegmentation.close();
      this.loadMenu(this.paramBoModel, this.indexSelect, true);
      this.cd.detectChanges();
    }
  }

  //closeModal(): void {
  //  this.closeModalButton.nativeElement.click();
  //  this.showModal = false;
  //}

  private loadMenu(paramBoModel: ParameterBoModel, indexSelected: number, refreshData: boolean = false): void {
    this.indexSelect = indexSelected;
    this.dialogservice.showSplash(true);
    const p1: string = !paramBoModel.P1 ? '' : paramBoModel.P1;
    const p2: string = !paramBoModel.P2 ? '' : paramBoModel.P2;
    const p3: string = !paramBoModel.FILE ? '' : paramBoModel.FILE;
    this.boName = p1;
    const path: string = `${this.indParam.AppParams.apiUrl}api/segmentation/getData/INITDATA/${p1}|${p2}|${p3}`;
    this.http.getHttp<SegmentationModel>(path).subscribe((result: SegmentationModel) => {
      if (!result.HasError) {
        this.boModel = new BObjectModel();
        this.boModel.IdDonneeFils = result.IdDonneeFils;
        this.boModel.IdDonneePere = result.IdDonneePere;
        this.boModel.IdentBO = '';
        this.boModel.IdentBODisplay = result.Items[0].idBO;
        this.boModel.Mode = 'CREATE';
        this.boModel.IdRelation = result.Items[0].idRelation;
        this.boModel.ShowSaveButton = result.Items[0].showSaveButton;
        this.boModel.ShowRemoveButton = result.Items[0].showRemoveButton;
        this.boModel.ShowCreateButton = result.Items[0].showCreateButton;
        this.boModel.ShowImportButton = result.Items[0].showImportButton;
        this.rank = result.rank;
        this.tabsList = result.Items;

        this.model = {
          component: indexSelected === 0 ? 'bo' : 'grid',
          model: indexSelected === 0 ? this.boModel : this.customgridParams,
          title: this.tabsList[indexSelected].title,
          activeButton: indexSelected === 0 ? undefined : this.activeButton
        };

        this.tabsList[indexSelected].isSelected = true;
        this.getModel(indexSelected, this.tabsList[indexSelected]);
        this.refreshData = refreshData;
      }
      this.dialogservice.showSplash(false);
    });
  }

  private getModel(tabindex: number, tabItem: SegmentationItem): void {
    this.loadComponent = false;
    this.model = { component: '', model: {}, title: '' };
    this.indexSelect = tabindex;
    if (this.indexSelect !== 0) {
      this.customgridParams = new CustomgridModel();
      this.customgridParams.cgParameters = new CustomgridParam();
      //   nomfichier|IsDashboard|IdRelation|IdDonnee|Origine|IdBO|CompleteWhere|IsRelationReel
      this.customgridParams.cgParameters.FileName = tabItem.file;
      this.customgridParams.cgParameters.IsDashboard = false;
      this.customgridParams.cgParameters.IdRelation = tabItem.idRelation;
      this.customgridParams.cgParameters.IdDonnee = this.boModel.IdDonneeFils;
      this.customgridParams.cgParameters.Origine = tabItem.origine;
      this.customgridParams.cgParameters.IdBO = tabItem.idBO;
      this.customgridParams.cgParameters.CompleteWhere = tabItem.completeWhere;
      if (tabItem.sort)
        this.customgridParams.cgParameters.CompleteOrderBy = `${tabItem.sort} ${tabItem.sortDirection}`;
      this.customgridParams.cgParameters.IsRelationReel = tabItem.isRelationReel;
      this.customgridParams.cgParameters.Mode = `INITDATA`;
      this.customgridParams.cgParameters.ShowSaveButton = tabItem.showSaveButton;
      this.customgridParams.cgParameters.ShowImportButton = tabItem.showImportButton;
      this.customgridParams.cgParameters.ShowRemoveButton = tabItem.showRemoveButton;
      this.customgridParams.cgParameters.ShowCreateButton = tabItem.showCreateButton;
      this.customgridParams.cgParameters.ShowContextColumn = this.showContextColumn && tabItem.OpenContext;
      this.activeButton = new Array<HtmlButton>();
      let button: HtmlButton = new HtmlButton('btnEnregistrer', 'BUTTON');
      button.Visible = tabItem.showSaveButton;
      this.activeButton.push(button);
      button = new HtmlButton('btnSupprimer', 'BUTTON');
      button.Visible = tabItem.showRemoveButton;
      this.activeButton.push(button);
      button = new HtmlButton('btnModeCreer', 'BUTTON');
      button.Visible = tabItem.showCreateButton;
      this.activeButton.push(button);
      button = new HtmlButton('btnImporter', 'BUTTON');
      button.Visible = tabItem.showImportButton;
      this.activeButton.push(button);
      this.model = { component: 'grid', model: this.customgridParams, title: tabItem.title, activeButton: this.activeButton };
      this.cd.detectChanges();
    } else {
      this.model = { component: 'bo', model: this.boModel, title: tabItem.title };
      this.cd.detectChanges();
    }
    this.loadComponent = true;
  }

  private setOffset(): void {
    this.baseHeaderHeight = GetHeaderHeight(this.indParam.Context);
    if ($('#tabsList').length > 0) {
      setTimeout((): void => {
        const tlh: number = parseInt($('#tabsList').css('height'));
        this.baseTagsListHeight = tlh > 0 && tlh !== this.baseTagsListHeight ? tlh : this.baseTagsListHeight;
        this.gridOffset = this.baseHeaderHeight;      // app header height
        this.gridOffset += this.baseTagsListHeight;   // segmentation tabs row height
        this.gridOffset += (16 + 10);                 // we add 16px (for the mt-3 on components' row) + 10px for tolerance
      }, 100);
    }
  }
}
